<template>
  <div class="c-posts-list js-x-scroll-target-lg">
    <template v-for="post in posts">
      <transition name="fade">
        <div :id="post.uid" :class="`c-post-card c-post-card--${toCssName(post.data.category)}`" :key="post.uid" >
          <router-link class="c-post-card__link" :to="{ name: 'post', params: { id: post.uid }}">
            <div v-if="post.data.featured_image.url" class="c-post-card__media">
              <img class="c-post-card__image" :src="post.data.featured_image.url" :alt="post.data.featured_image.alt" :width="getWidth(post.data.featured_image)" :height="getHeight(post.data.featured_image)" >
            </div>
            <div class="c-post-card__content">
              <h4 class="c-posts-card__meta-category" v-html="post.data.category"></h4>
              <div class="c-post-card__title-wrapper">
                <h3 class="c-post-card__title" v-html="getTextContent(post.data.title)" />
                <p class="c-post-card__lead" v-text="getTextContent(post.data.subtitle)" />
                <a class="c-post-card__btn">Read More</a>
              </div>
            </div>
          </router-link>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'posts-list',
  components: {},
  props: ['posts'],
  methods: {
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    getHtmlContent (str) {
      return str ? PrismicDOM.RichText.asHtml(str) : ''
    },
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    },
    getWidth (img) {
      return img.dimensions ? img.dimensions.width : null
    },
    getHeight (img) {
      return img.dimensions ? img.dimensions.height : null
    }
  },
  mounted () {
    this.$emit('ready')
  }
}
</script>

<style scoped lang="scss">
.c-posts-list {
  @media (min-width: $breakpoint-md) {
    display: flex;
    flex-wrap: nowrap;
    height: 100vh;
    align-items: center;
  }

  @media (min-width: $breakpoint-lg) {
    overflow-x: auto;
    overflow-y: hidden;
  }
}

.c-post-card {
  position: relative;
  padding: 2rem 0;
  box-shadow: inset -10px 0px 0px 0px #eee;
  // box-shadow: inset -6px -11px 20px 0px #eee;
  overflow: hidden;
     -webkit-backface-visibility: hidden;
   -moz-backface-visibility: hidden;
   -ms-backface-visibility: hidden;
   backface-visibility: hidden;

   -webkit-perspective: 1000;
   -moz-perspective: 1000;
   -ms-perspective: 1000;
   perspective: 1000;
  // fill up transition, removed in round 1 of amends
  // background-size: 200% 200%;
  // background-image: linear-gradient(to right, white 0%, #f9f9f9 100%, #f9f9f9 100%, #f9f9f9 100%);
  // background-image: linear-gradient(to top, $leadership 50%, transparent 50%);
  // transition: background-position 400ms, box-shadow 400ms ease, color 600ms ease;

  // simple fade added
  background-color: #fff;
  transition: background-color .5s ease, color 600ms ease;

  @media (min-width: $breakpoint-md) {
    flex: 0 0 440px;
    padding: 0;
  }

  @media (min-width: $breakpoint-xl) {
    flex: 0 0 560px;
  }

  &:before {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-left: 60px solid #eee;
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: z('stat-block-before');
  }

  &:hover {
    color: #262630;
    // background-position: 0 100%;
    box-shadow: none;
  }
}

.c-post-card--leadership {
  // background-image: linear-gradient(to top, $leadership, 50%, transparent 50%);

  &:before {
    border-left: 60px solid $leadership;
  }

  &:hover {
    background-color: $h_green;
    // background-color: darken($leadership, 10%);
    // background-image: linear-gradient(to top, $leadership 50%, transparent 50%);

    &:before {
      border-left: 60px solid $leadership;
    }
  }
}

.c-post-card--legal-market {
  // background-image: linear-gradient(to top, $legal-market 50%, transparent 50%);

  &:before {
    border-left: 60px solid $legal-market;
  }

  &:hover {
    background-color: $h_purple;
    // background-color: darken($legal-market, 10%);
    // background-image: linear-gradient(to top, $legal-market 50%, transparent 50%);

    &:before {
      border-left: 60px solid $legal-market;
    }
  }
}

.c-post-card--legal-tech {
  // background-image: linear-gradient(to top, $legal-tech 50%, transparent 50%);

  &:before {
    border-left: 60px solid $legal-tech;
  }

  &:hover {
    background-color: $h_blue;
    // background-color: darken($legal-tech, 10%);
    // background-image: linear-gradient(to top, $legal-tech 50%, transparent 50%);

    &:before {
      border-left: 60px solid $legal-tech;
    }
  }
}

.c-post-card--management {
  // background-image: linear-gradient(to top, $management 50%, transparent 50%);

  &:before {
    border-left: 60px solid $management;
  }

  &:hover {
    background-color: $h_pink;
    // background-color: darken($management, 10%);
    // background-image: linear-gradient(to top, $management 50%, transparent 50%);

    &:before {
      border-left: 60px solid $management;
    }
  }
}

.c-post-card:hover .c-post-card__content * {
  border-color: #fff;
  color: #fff;
}

.c-post-card__link {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 240px;

  @media (min-width: $breakpoint-md) {
    height: 100vh;
  }
}

.c-post-card__media {
  position: absolute;
  bottom: 50vh;
  // top: 4rem;
  left: 50%;
  width: 100%;
  opacity: 0;
  // transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%);
  transition: top 100ms ease, opacity 100ms ease;

  @media (min-width: $breakpoint-md) {
    // top: 7rem;
  }

  @media (min-width: $breakpoint-lg) {
    // top: 6rem;
  }
}

.c-post-card:hover .c-post-card__media {
  // top: 2rem;
  bottom: 56vh;
  opacity: 1;
  // transition: top 500ms ease, opacity 500ms ease;
  transition: bottom 500ms ease, opacity 500ms ease;

  // @media (min-height: $breakpoint-md) {
  //   bottom: 56vh;
  // }

  @media (min-width: $breakpoint-lg) {
    // top: 3rem;
  }
}

.c-post-card__image {
  width: 100%;
  // max-width: 100%;
  max-width: unset;
  // object-fit: cover;
}

#cheaper-faster-better-changing-client-expectations  .c-post-card__image {
    width: 200%;
}

#brave-new-world-the-future-of-law .c-post-card__image {
    width: 250%;
}

/* END PANELS */

.c-post-card__content {
  color: $color-body-content;
  padding: 0 2rem;
  transition: color 600ms ease, border-color .2s ease, margin 500ms ease;
  overflow: hidden;

  @media (min-width: $breakpoint-md) {
    margin: 0 auto;
    width: 100%;
  }
}

.c-post-card:hover .c-post-card__content {
  // @media (max-height: 480px) {
  //   margin-bottom: -100px;
  // }
  @media (min-width: $breakpoint-lg) {
    margin-bottom: -200px;
  }
}

.c-posts-card__meta-category {
  font-size: .7rem;
  font-style: italic;
  font-weight: 300;
  padding-left: 1.7rem;
  position: relative;
  text-transform: uppercase;

  @media (min-width: $breakpoint-lg) {
    font-size: 1rem;
    padding-left: 2.5rem;
  }

  &::before {
    background-color: red;
    content: "";
    display: block;
    height: 10px;
    left: 0px;
    position: absolute;
    transform: rotate(-45deg);
    top: 0px;
    width: 10px;
  }
}

.c-post-card:hover .c-posts-card__meta-category::before {
  background-color: #fff;
}

.c-post-card--leadership .c-posts-card__meta-category::before {
  background-color: $leadership;
}

.c-post-card--legal-market .c-posts-card__meta-category::before {
  background-color: $legal-market;
}

.c-post-card--legal-tech .c-posts-card__meta-category::before {
  background-color: $legal-tech;
}

.c-post-card--management .c-posts-card__meta-category::before {
  background-color: $management;
}

.c-post-card__title-wrapper {
  border-left: 1px solid #000;
  margin-left: 5px;
  padding-bottom: 0rem;
  padding-left: 2rem;
  position: relative;

  &:after {
    content: "";
    background-color: #000;
    bottom: 0;
    left: -6px;
    position: absolute;
    height: 1px;
    width: 12px;
  }
}

.c-post-card:hover .c-post-card__title-wrapper::after {
  background-color: #fff;
}

.c-post-card:hover .c-post-card__title-wrapper {
  @media (min-width: $breakpoint-lg) {
    padding-bottom: 5rem;
  }
}

.c-post-card__title {
  margin: 0;
  font-family: $font-heading;
  font-size: 1.2rem;
  font-weight: $font-heading-weight;
  line-height: 1.2;
  text-transform: uppercase;

  @media (min-width: $breakpoint-lg) {
    font-size: 1.8rem;
  }
}

.c-post-card__lead {
  display: none;
  font-size: 18px;
  line-height: 1.3;
  width: 100%;
}

.c-post-card:hover .c-post-card__lead {
  @media (min-width: $breakpoint-lg) {
    display: block;
  }
}

.c-post-card__btn {
  background-color: transparent;
  border: 2px solid #fff;
  box-shadow: 5px 5px 0px -1px #fff;
  color: #fff;
  display: inline-block;
  font-family: $font-heading;
  font-size: .75rem;
  font-weight: $font-heading-weight;
  margin-top: 0;
  opacity: 0;
  padding: .3rem;
  position: absolute;
  transition: margin 800ms ease;
  text-transform: uppercase;

  @media (min-width: $breakpoint-lg) {
    font-size: .8rem;
    margin-top: 2rem;
    padding: .5rem;
  }
}

.c-post-card--leadership .c-post-card__btn:hover {
  background-color: darken($leadership, 5%);
}

.c-post-card--legal-market .c-post-card__btn:hover {
  background-color: darken($legal-market, 5%);
}

.c-post-card--legal-tech .c-post-card__btn:hover {
  background-color: darken($legal-tech, 5%);
}

.c-post-card--management .c-post-card__btn:hover {
  background-color: darken($management, 5%);
}

.c-post-card:hover .c-post-card__btn {
  opacity: 1;
}

.c-post-card:active .c-post-card__btn {
  box-shadow: 2px 2px 0px -1px #fff;
  font-size: .75rem;
}

</style>



// WEBPACK FOOTER //
// PostsList.vue?36e50ca7